import { render, staticRenderFns } from "./GroupOffer.vue?vue&type=template&id=1981fe30&"
import script from "./GroupOffer.vue?vue&type=script&lang=js&"
export * from "./GroupOffer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports